import { CommonContainerInterface } from 'common/types/entities/EntityInterface'
import {
  containerCss,
  fontCss,
  mobileFontCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

interface ProductContainerUiProps extends CommonContainerInterface {
  fontFamily?: string
  fontStyle?: string
  fontWeight?: string
  mobileFontFamily?: string
  mobileFontStyle?: string
  mobileFontWeight?: string
}

const ProductContainerUi = styled.div<ProductContainerUiProps>`
  ${containerCss}
  ${fontCss}
  ${p => p.theme.phone} {
    ${mobileFontCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileFontCss}
    `}
`

export default ProductContainerUi
